import { AbstractControl } from "@angular/forms";

export function removeSpaces(control: AbstractControl) {
  if (!control.value) return null;
  var isSpace: boolean = !control.value.replace(/\s/g, "").length;
  var isStartorEnd: boolean = control.value !== control.value.trim();
  return isSpace || isStartorEnd ? { whitespace: true } : null;
}
